
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

export default function MethodSelection({ value, handleChange }) {
  return (
    <FormControl variant="standard" sx={{ m: 1, minWidth: 130 }}>
    <InputLabel id="demo-simple-select-standard-label">Method</InputLabel>
    <Select
      labelId="demo-simple-select-standard-label"
      id="demo-simple-select-standard"
      value={value}
      onChange={handleChange}
    >
      <MenuItem value={"Linear"}>Linear Trend</MenuItem>
      <MenuItem value={"Weights"}>Weights</MenuItem>
      <MenuItem value={"Manual"}>Manual</MenuItem>
      <MenuItem value={"Exponential"}>Exponential</MenuItem>
    </Select>
    </FormControl>
  );
}